import { cleanEntityStyles } from './clean-entity-styles'
import { cleanEntityPricing } from './clean-entity-pricing'
import { cleanEntityPrinting } from './clean-entity-printing'
import { cleanEntityInclusions } from './clean-entity-inclusions'
import { cleanEntityRequirements } from './clean-entity-requirements'
import { cleanEntitySuggestions } from './clean-entity-suggestions'
import { cleanEntityTaxes } from './clean-entity-taxes'
import { cleanEntityKps } from './clean-entity-kps'

export function cleanDepartmentCategory (category, department, menuBlob, forPublish = false) {
  cleanEntityStyles(category, department)
  cleanEntityPrinting(category, department, menuBlob)
  cleanEntityKps(category, department, menuBlob)
  cleanEntityTaxes(category, menuBlob)
  cleanEntityPricing(category, department, menuBlob, forPublish)
  cleanEntityInclusions(category, menuBlob)
  cleanEntityRequirements(category, department, menuBlob)
  cleanEntitySuggestions(category, menuBlob)
}
